// extracted by mini-css-extract-plugin
export default {"li":"Perk_li__oMQfr","detail":"Perk_detail__4lso6","h1":"Perk_h1__a+dp9","p":"Perk_p__6sT4m"};